<template>
    <div>
        <div class='radio-list flex flex-wrap justify-center items-start pb5 w-100'>
            <radio-card v-for='(radio, index) in radios'
                        :key='index'
                        :radio='radio'></radio-card>
        </div>
    </div>
</template>

<script>

import RadioCard from '@/components/localRadios/RadioCard'
import {mapActions} from 'vuex'

export default {
  name: 'RadiosList',
  components: {RadioCard},
  props: {
  },
  data () {
    return {
      radios: []
    }
  },
  created () {
    let country = localStorage.getItem('providerCountry')
    if (country) {
      this.getLocalRadios(country).then(radios => {
        this.radios = radios
      })
    }
  },
  mounted () {
    this.setPlaying(false)
  },
  methods: {
    ...mapActions('home', [
      'getLocalRadios'
    ]),
    ...mapActions('player', [
      'setPlaying'
    ])
  }
}
</script>

<style scoped lang='scss'>
  @import '~@/variables.scss';

  .radio-list {
    overflow-y: scroll;
    height: $main-height
  }
  @media screen and (max-width: 500px) {
    .artist-card {
      width: 20rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/localRadios/RadiosList.vue